import type {ReactNode} from 'react';

export default function AssistantMark({className}: {className?: string}): ReactNode {
  return (
    <svg
      className={className}
      viewBox="0 0 32 32"
      fill="none"
      aria-hidden="true"
      focusable="false">
      <path d="M5 7.5 16 4l11 3.5v15L16 28 5 22.5v-15Z" fill="currentColor" opacity=".16" />
      <path d="M7.5 9.25 16 6.5l8.5 2.75v11.5L16 25l-8.5-4.25V9.25Z" stroke="currentColor" strokeWidth="1.7" />
      <path d="M16 7v17.5M8 9.5l8 3 8-3" stroke="currentColor" strokeWidth="1.7" />
      <path d="m21.5 3 .72 1.78L24 5.5l-1.78.72L21.5 8l-.72-1.78L19 5.5l1.78-.72L21.5 3Z" fill="currentColor" />
    </svg>
  );
}
